import { BREAKPOINTS } from '@/js/lib/constants';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const elements = document.querySelectorAll<HTMLElement>(
  '.js-multi-column-info'
);

const initSwiper = (el: HTMLElement) => {
  const pagination = el.querySelector<HTMLElement>('.carousel-pagination');

  const s = new Swiper(el, {
    modules: [Pagination],
    pagination: { el: pagination, clickable: true },
    observer: true,
    observeParents: true,
    breakpoints: {
      [BREAKPOINTS.md]: {
        enabled: false,
      },
    },
  });

  s.on('slideChange', () => {
    try {
      s.pagination?.update();
    } catch (e) {
      // ignore if pagination isn't available for whatever reason
    }

    try {
      const bullets = pagination?.querySelectorAll<HTMLElement>('.swiper-pagination-bullet');
      const activeIndex = s.realIndex ?? s.activeIndex ?? 0;

      if (bullets && bullets.length) {
        bullets.forEach(b => b.classList.remove('swiper-pagination-bullet-active'));
        const activeBullet = bullets[activeIndex];
        if (activeBullet) activeBullet.classList.add('swiper-pagination-bullet-active');
      }
    } catch (err) {
      // swallow any debug errors
    }
  });

  s.update();
  s.pagination?.render();
  s.pagination?.update();

  return s;
};

function carousel(el: HTMLElement) {
  const media = window.matchMedia(`(min-width: ${BREAKPOINTS.md}px)`);
  let swiper: undefined | Swiper;

  const handleInit = ({ matches }: { matches: boolean }) => {
    if (matches) {
      if (swiper) {
        try {
          swiper.pagination?.destroy();
        } catch (e) {
          console.warn('Failed to destroy pagination', e);
        }
        try {
          swiper.destroy(true, true);
        } catch (e) {
          console.warn('Failed to destroy swiper', e);
        }
        swiper = undefined;
      }
      return;
    }

    if (!swiper) {
      swiper = initSwiper(el);
    } else {
      swiper.update();
      swiper.pagination?.update();
    }
  };

  media.addEventListener('change', handleInit);
  handleInit(media);
}
elements.forEach(carousel);
